import * as types from '../type/Router.type';
let Router = {
    headerActive: (path) => {
        return {
            type: 'a',
            res: path
        }
    },
    istop: (istop) => {
        return {
            type: types.IS_TOP_PAGE,
            res: istop
        }
    },
    isVedio: (isvedio) => {
        return {
            type: types.IS_VEDIO_PAGE,
            res: isvedio
        }
    },
    getSchoolPath:(path)=>{
        return {
            type: types.GET_SCHOOL_PATH,
            res: path
        }
    }
}

export default Router;


// WEBPACK FOOTER //
// ./src/redux/action/Router.action.js